import { PropsWithChildren } from 'react';
import { Stack, Typography, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GeoEventCreatedByLine } from 'features/geoEvents/components/GeoEventMetadataRows';

type EmbedGeoEventInfoProps = {
  title: string;
  createdByName: {
    displayNameShort: string;
    displayName: string | null;
    abbreviationName: string | null;
  };
  dateCreated: Date;
  isActive: boolean;
};

const useStyles = makeStyles()((theme: Theme) => ({
  titleHeader: {
    fontWeight: 600,
    marginRight: theme.spacing(0.75),
  },
}));

export const EmbedGeoEventInfo = (
  props: PropsWithChildren<EmbedGeoEventInfoProps>,
): JSX.Element => {
  const { title, createdByName, dateCreated, isActive, children } = props;
  const { classes } = useStyles();

  return (
    <Stack spacing={2}>
      <Typography className={classes.titleHeader} variant="h3">
        {title}
      </Typography>

      {children}

      <GeoEventCreatedByLine
        createdByName={createdByName}
        dateCreated={dateCreated}
        isActive={isActive}
        variant="embed"
      />
    </Stack>
  );
};
